import { render, staticRenderFns } from "./Tiempo.vue?vue&type=template&id=537d5750&"
import script from "./Tiempo.vue?vue&type=script&lang=js&"
export * from "./Tiempo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports